module.exports = __webpack_public_path__ + "img/big-plus.fcc1e79e.svg";